module.exports = __webpack_public_path__ + "img/detail1.e12da2d5.png";